<template lang="pug">
.v-field-check-list.field-check-list(:class="{'field-check-list--disabled': field.disabled, 'field-check-list--editable': field.editable, 'field-check-list--has-head': field.headText || field.headQuantity, 'field-check-list--radio': field.type === 'radio-list', 'field-check-list--checkbox': field.type === 'check-list'}")
	v-loader(:loading="loading" v-if="loading")
	.field-check-list__label-wrap(v-if="field.label")
		.field-check-list__label
			| {{field.label}}
			span.field-text__star(v-if="field.required") *
		button.field-check-list__reset(type="button" v-if="localValue && localValue.length" @click="reset")
			.field-check-list__reset-text Очистить
			.field-check-list__reset-icon-wrap
				v-svg-icon.field-check-list__reset-icon(icon="close-xs")
	.field-check-list__head(v-if="field.headText || field.headQuantity")
		.field-check-list__head-text {{field.headText}}
		.field-check-list__head-quantity {{field.headQuantity}}
	template(v-if="field.searchable || field.searchAjax")
		.field-check-list__field-text.field-text(:class="{'field-text--placeholder-state': checkPlaceholderState}")
			.field-placeholder(v-if="field.placeholder") {{field.placeholder}}{{field.required ? "*" : null}}
			input.field-input(
					ref="input"
					type="text"
					:inputmode="field.inputmode"
					:disabled="field.disabled"
					v-model="selectValueText"
					@input="searchAjaxCheck"
					@focus="inputFocus"
					@blur="inputBlur"
					:id="uniqueId"
					@keyup="foundSelectValue")
	.field-check-list__items.flc
		template(v-if="(field.searchable || field.searchAjax)")
			template(v-if="selectValueText")
				.field-check-list__item.flc(v-for="(option, index) in field.options" :key="option.value + '-' + index")
					template(v-if="isFoundSelectText(option.text)")
						v-field-checkbox(:true-value="option.value"
								:text="option.text"
								:note="option.note"
								:description="option.description"
								:quantity="option.quantity"
								:label="option.label"
								:show-username="option.showUsername"
								:disabled="option.disabled || field.disabled"
								v-model="localValue"
								@update:model-value="handleInput"
								:radio="radio"
								:size="field.size"
								:centered="field.centered")
				.field-check-list__list-item.field-check-list__list-item--message(v-if='selectValueText && selectValueText.length > 0 && !isSelectValueFound') Ничего не найдено
			template(v-else)
				template(v-for="(option, index) in field.options" :key="option.value + '-' + index")
					template(v-if="field.options.length > 5 ? index < 5 : true")
						.field-check-list__item.flc
							v-field-checkbox(:true-value="option.value"
									:text="option.text"
									:note="option.note"
									:description="option.description"
									:quantity="option.quantity"
									:label="option.label"
									:show-username="option.showUsername"
									:disabled="option.disabled || field.disabled"
									v-model="localValue"
									@update:model-value="handleInput"
									:radio="radio"
									:size="field.size"
									:centered="field.centered")
				.field-check-list__spoiler(v-if="field.options.length > 5 && open")
					template(v-for="(option, index) in field.options" :key="option.value + '-' + index")
						template(v-if="index >= 5")
							.field-check-list__item.flc
								v-field-checkbox(:true-value="option.value"
										:text="option.text"
										:note="option.note"
										:description="option.description"
										:quantity="option.quantity"
										:label="option.label"
										:show-username="option.showUsername"
										:disabled="option.disabled || field.disabled"
										v-model="localValue"
										@update:model-value="handleInput"
										:radio="radio"
										:size="field.size"
										:centered="field.centered")
				button.field-check-list__spoiler-bar(v-if="field.options.length > 5" type="button" :class="{'open': open}" @click="open = !open")
					.field-check-list__spoiler-bar-text(v-if="!open") Показать все
					.field-check-list__spoiler-bar-text(v-if="open") Свернуть
					v-svg-icon.field-check-list__spoiler-bar-icon(icon="chevron-down-sm")
		template(v-else)
			.field-check-list__check-all-field(v-if="field.checkAll")
				v-field-checkbox(:true-value="true"
						text="Выбрать все"
						v-model="checkAllValue"
						@update:model-value="checkAllCheckboxes")
			template(v-for="(option, index) in field.options" :key="option.value + '-' + index")
				template(v-if="field.multiple ? true : (field.noSpoiler ? true : (field.options.length > 5 ? index < 5 : true))")
					.field-check-list__item.flc
						v-field-checkbox(
								:true-value="option.value"
								:text="option.text"
								:note="option.note"
								:description="option.description"
								:quantity="option.quantity"
								:label="option.label"
								:show-username="option.showUsername"
								:disabled="option.disabled || field.disabled"
								v-model="localValue"
								@update:model-value="handleInput"
								:radio="radio"
								:size="field.size"
								:field="field"
								:editable="option.editable"
								:centered="field.centered"
								:placeholder="option.placeholder"
								:default-text="option.defaultText")
			.field-check-list__spoiler(v-if="field.options.length > 5 && open")
				template(v-for="(option, index) in field.options" :key="option.value + '-' + index")
					template(v-if="field.multiple ? true : index >= 5")
						.field-check-list__item.flc
							v-field-checkbox(:true-value="option.value"
									:text="option.text"
									:note="option.note"
									:description="option.description"
									:quantity="option.quantity"
									:label="option.label"
									:show-username="option.showUsername"
									:disabled="option.disabled || field.disabled"
									v-model="localValue"
									@update:model-value="handleInput"
									:radio="radio"
									:size="field.size"
									:field="field"
									:editable="option.editable"
									:centered="field.centered"
									:placeholder="option.placeholder"
									:default-text="option.defaultText")
			button.field-check-list__spoiler-bar(v-if="!field.noSpoiler && !field.multiple && field.options.length > 5" type="button" :class="{'open': open}" @click="open = !open")
				.field-check-list__spoiler-bar-text(v-if="!open") Показать все
				.field-check-list__spoiler-bar-text(v-if="open") Свернуть
				v-svg-icon.field-check-list__spoiler-bar-icon(icon="chevron-down-sm")
			button.field-check-list__multiple-bar.btn.btn--outline(v-if="field.multiple && (field.multipleLimit ? field.options.length < field.multipleLimit : true)"
					type="button"
					@click="addNewOption")
				v-svg-icon.field-check-list__multiple-bar-icon.btn__icon(icon="multiple")
				.field-check-list__multiple-bar-text.btn__text Создать список
	.field-description(v-if="field.description")
		v-svg-icon.field-description__description-icon(icon="note")
		.field-description__description-text(v-html="field.description")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import uniqueId from '../scripts/helpers/uniqueId.js';

export default {
	mixins: [
		sourceMixin
	],

	props: {
		radio: {
			type: Boolean,
			default: false
		},

		field: {
			type: Object,
			required: true,
			default: null
		},

		modelValue: {
			type: [Object, String, Number, Boolean],
			default: null
		}
	},

	emits: [
		'update:model-value'
	],

	data() {
		return {
			loading: false,
			options: null,
			timerId: 0,
			localValue: null,
			open: false,
			uniqueId: uniqueId('field-'),
			selectValueText: '',
			isSelectValueFound: false,
			hasFocus: false,
			newOptions: [],
			checkAllValue: false,
		};
	},

	watch: {
		modelValue() {
			this.updateLocalValue();
		}
	},

	created() {
		this.updateLocalValue();
	},

	computed: {
		checkPlaceholderState() {
			return !this.hasFocus && (this.selectValueText === null || this.selectValueText === '' || this.selectValueText.length === 0);
		},
	},

	methods: {
		checkAllCheckboxes() {
			this.localValue = [];
			if (this.checkAllValue) {
				this.field.options.forEach(option => {
					this.localValue.push(option.value);
				});
			}
			this.handleInput();
		},

		addNewOption() {
			let counter = this.newOptions.length;
			this.newOptions.push({
				value: this.field.placeholder + (counter ? ` ${counter}` : ''),
				text: this.field.placeholder + (counter ? ` ${counter}` : ''),
			});
			this.field.options.push({
				text: this.field.placeholder + (counter ? ` ${counter}` : ''),
				defaultText: this.field.defaultText + (counter ? ` ${counter}` : ''),
				placeholder: this.field.placeholder,
				editable: this.field.editable
			});
		},

		reset() {
			this.localValue = [];
			this.handleInput();
		},

		updateLocalValue() {
			this.localValue = this.modelValue;
		},

		handleInput() {
			this.$emit('update:model-value', this.localValue);
		},

		dataSet(data) {
			if (!data) {
				return;
			}
			this.foundSelectValue();
			if (data.searchResult) {
				this.field.options = this.options = data.searchResult;
				this.open = true;
			} else if (data.options) {
				this.options = data.options;
			}
			this.updateLocalValue();
		},

		searchAjaxCheck() {
			if (this.field.searchAjax) {
				this.open = false;
				clearTimeout(this.timerId);
				this.timerId = setTimeout(this.searchAjax, 500);
			} else {
				if (this.selectValueText) {
					this.open = true;
				} else {
					this.open = false;
				}
			}
		},

		searchAjax() {
			if (!this.selectValueText || this.selectValueText.trim().length < 3) {
				return
			}
			this.localValue = [];
			this.localValueText = '';
			this.dataLoad({
				url: this.field.searchAjax.remote,
				data: {
					bxajaxid: this.field.searchAjax.bxajaxid,
					ajaxSearch: this.selectValueText.trim(),
					fieldCode: this.field.code
				},
				delay: false
			}, null)
		},

		isFoundSelectText(text = '') {
			if (this.field.searchAjax) {
				return true;
			}
			let result = false;
			let selectValueText = this.selectValueText;
			if (!selectValueText) {
				selectValueText = '';
			}
			if (text.toLowerCase().indexOf(selectValueText.toLowerCase()) !== -1) {
				result = true;
			} else {
				result = false;
			}
			return result;
		},

		inputFocus() {
			this.hasFocus = true;
		},

		inputBlur() {
			this.hasFocus = false;
		},

		foundSelectValue() {
			let result = false;
			if (this.field && this.field.options && this.field.options.length) {
				for (let i = 0; i < this.field.options.length; i++) {
					if (this.isFoundSelectText(this.field.options[i].text)) {
						result = this.field.options[i].text;
						this.isSelectValueFound = true;
						break;
					}
				}
				if (result) {
					this.isSelectValueFound = true;
				} else {
					this.isSelectValueFound = false;
				}
			}
			return result;
		},
	},
};
</script>
